
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
const Sports = () => {
    const [section, setSection] = useState("Zonallevel");
    useEffect(() => {

    })
    return (
        <>
            <div className="breadcrumb">
                <h2>Co-Curricular Activities</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Events & Activities</li>
                    <li>|</li>
                    <li>Co-Curricular Activities</li>
                </ul>
            </div>
            <div className="inner_page faculty_inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex">
                                <button className={section === "Zonallevel" ? 'active' : ''} onClick={() => setSection("Zonallevel")}>Zonal level Athletic Meet</button>
                                <button className={section === "Olympiad" ? 'active' : ''} onClick={() => setSection("Olympiad")}>Olympiad</button>
                                <button className={section === "SeniorSportsDay" ? 'active' : ''} onClick={() => setSection("SeniorSportsDay")}>Senior Sports Day</button>
                                <button className={section === "SportsDay" ? 'active' : ''} onClick={() => setSection("SportsDay")}>Sports Day</button>
                                <button className={section === "FootballTournament" ? 'active' : ''} onClick={() => setSection("FootballTournament")}>Football Tournament</button>
                                <button className={section === "CricketTournament" ? 'active' : ''} onClick={() => setSection("CricketTournament")}>Cricket Tournament</button>
                                <button className={section === "AbacusPrize" ? 'active' : ''} onClick={() => setSection("AbacusPrize")}>Abacus Prize</button>
                            </div>
                        </div>
                    </div>

                    {section === "Zonallevel" && (
                        <div className="row">
                            <div className="col-md-12"><h3 className="heading">Zonal level Athletic Meet</h3></div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/assem7.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/assem7.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/assem6.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/assem6.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>                           
                        </div>
                    )
                    }
                    {section === "Olympiad" && (
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="heading">Olympiad</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/olimpiad1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/olimpiad1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/olimpiad2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/olimpiad2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/olimpiad3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/olimpiad3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/olimpiad4.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/olimpiad4.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                        </div>
                    )
                    }
                    {section === "SeniorSportsDay" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Senior Sports Day</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/Senior_sports_day_1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Senior_sports_day_1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/Senior_sports_day_2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Senior_sports_day_2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>

                        </div>
                    )

                    }
                    {section === "SportsDay" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Sports Day</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sports_day_1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sports_day_1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sports_day_2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sports_day_2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sports_day_3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sports_day_3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>

                        </div>
                    )

                    }
                    {section === "FootballTournament" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Football Tournament</h3>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/footbal1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/footbal1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/footbal2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/footbal2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div> 
                        </div>
                    )

                    }
                    {section === "CricketTournament" && (
                        <div class="row g-3">
                            <div className="col-md-12"><h3 className="heading">Cricket Tournament</h3></div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/cricket1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/cricket1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/cricket2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/cricket2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/cricket3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/cricket3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/cricket4.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/cricket4.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            
                        </div>
                    )

                    }
                    {section === "AbacusPrize" && (
                        <div class="row g-3">
                            <div className="col-md-12"><h3 className="heading">Abacus Prize</h3></div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/Abacus-Prize1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Abacus-Prize1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/Abacus-Prize2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Abacus-Prize2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/Abacus-Prize3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Abacus-Prize3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            <div class="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/Abacus-Prize4.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Abacus-Prize4.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" /></a>
                            </div>
                            
                        </div>
                    )

                    }


                </div>
            </div>
        </>
    )
}

export default Sports
